document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper = [];

    document.querySelectorAll('.swiper-slider').forEach((element, i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`, "");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    // Slider Reviews
    const reviewsContainer = document.querySelector('.reviews__slider');
    let reviewsSlider;
    if (reviewsContainer) {
        reviewsSlider = new Swiper('.reviews__slider', {
            loop: true,
            speed: 700,
            effect: 'fade',
            autoHeight:true,
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: '.reviews-pagination',
                clickable: true
            },
            navigation: {
                prevEl: '.swiper-prev-reviews',
                nextEl: '.swiper-next-reviews'
            }
        });

        reviewsSlider.on('slideChange', function () {
            let start = document.querySelector('.js-reviews-start');

            if(start) {
                start.innerHTML = reviewsSlider.realIndex + 1;
            }
        });
    }

    // Slider Gallery
    const galleryContainer = document.querySelector('.gallery-block__slider');
    let gallerySlider;

    if (galleryContainer) {
        gallerySlider = new Swiper('.gallery-block__slider', {
            slidesPerView: 1.15,
            initialSlide: 1,
            spaceBetween: 10,
            loop: true,
            centeredSlides: true,
            navigation: {
                nextEl: ".swiper-next-gallery",
                prevEl: ".swiper-prev-gallery",
            },
            breakpoints: {
                1280: {
                    slidesPerView: 1.8,
                    centeredSlides: true,
                    spaceBetween: 30,
                },
            },
        });

        gallerySlider.on('slideChange', function () {
            let start = document.querySelector('.js-gallery-block-start');

            if(start) {
                start.innerHTML = gallerySlider.realIndex + 1;
            }
        });
    }

    // Slider Block
    const sliderContainer = document.querySelector('.slider-block__container');
    let sliderDefault;

    if (sliderContainer) {
        sliderDefault = new Swiper('.slider-block__container', {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            speed: 600,
            slidesPerView: 1,
            navigation: {
                nextEl: ".swiper-next-slider",
                prevEl: ".swiper-prev-slider",
            },
        });

        sliderDefault.on('slideChange', function () {
            let start = document.querySelector('.js-slider-block-start');

            if(start) {
                start.innerHTML = sliderDefault.realIndex + 1;
            }
        });
    }

    // Slider with tabs
    const sliderWithTabsContainer = document.querySelector('.slider-with-tabs__container');
    let sliderWithTabs;

    if (sliderWithTabsContainer) {
        sliderWithTabs = new Swiper('.slider-with-tabs__container', {
            loop: true,
            speed: 700,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: ".swiper-next-slider-with-tabs",
                prevEl: ".swiper-prev-slider-with-tabs",
            },
            pagination: {
                el: ".swiper-pagination-with-tabs",
                clickable: true,
                renderBullet: function (index, className) {
                    var title = document.querySelectorAll('.slider-with-tabs__item')[index].getAttribute('data-title');
                    return '<li class="' + className + '"><span>' + title + '</span></li>';
                },
            }
        });

        sliderWithTabs.on('slideChange', function () {
            let start = document.querySelector('.js-slider-with-tabs-start');

            if(start) {
                start.innerHTML = sliderWithTabs.realIndex + 1;
            }
        });
    }

    // Slider Instagram
    const sliderInstagramContainer = document.querySelector('.instagram-block__slider .swiper-wrapper');
    let sliderInstagram;

    if (sliderInstagramContainer) {
        sliderInstagram = new Swiper('.instagram-block__slider', {
            loop: true,
            speed: 1000,
            slidesPerView: 1.05,
            initialSlide: 1,
            spaceBetween: 10,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            breakpoints: {
                992: {
                    slidesPerView: 4,
                    spaceBetween: 17,
                    centeredSlides: false,
                }
            }
        });
    }

    // Slider Venues
    const sliderVenuesContainer = document.querySelector('.slider-venues__slider');
    let sliderVenues;

    if (sliderVenuesContainer) {
        sliderVenues = new Swiper('.slider-venues__slider', {
            loop: true,
            speed: 1000,
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-venues-next",
                prevEl: ".swiper-venues-prev"
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                1440: {
                    slidesPerView: 2.22,
                    spaceBetween: 50
                },
                1920: {
                    slidesPerView: 2.9,
                    spaceBetween: 50
                }
            }
        });

        sliderVenues.on('slideChange', function () {
            let start = document.querySelector('.js-slider-venues-start');

            if(start) {
                start.innerHTML = sliderVenues.realIndex + 1;
            }
        });
    }

    // Single Single Reviews
    const SingleReviewsContainer = document.querySelector('.single-reviews__slider');
    let singleReviewsSlider;

    if (SingleReviewsContainer) {
        singleReviewsSlider = new Swiper('.single-reviews__slider', {
            loop: true,
            speed: 700,
            effect: 'fade',
            autoHeight:true,
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                prevEl: '.swiper-prev-single-reviews',
                nextEl: '.swiper-next-single-reviews'
            }
        });

        singleReviewsSlider.on('slideChange', function () {
            let start = document.querySelector('.js-single-reviews-start');

            if(start) {
                start.innerHTML = singleReviewsSlider.realIndex + 1;
            }
        });
    }
});
